import {
	POST_FICHE_OUVERTE_BEGIN,
	POST_FICHE_OUVERTE_ERROR,
	POST_FICHE_OUVERTE_RESET,
	POST_FICHE_OUVERTE_SUCCESS,
	SET_FICHE_PRISE,
	CLEAR_FICHE_PRISE,
	SET_FICHE_DEMANDE,
	CLEAR_FICHE_DEMANDE,
	SET_FICHE_DEMANDE_REPONSE,
	CLEAR_FICHE_DEMANDE_REPONSE,
} from "../actions/ficheOuverteActions"

const initialState = {
	fichesOuvertes: [],
	// Notif « fiche reprise par une autre session » destinée à CET onglet (le
	// perdant) : { fiche_id, type, by } | null. Pilote le modal de prise de main.
	prise: null,
	// Demande de prise de main reçue par le DÉTENTEUR (popup accepter/refuser) :
	// { fiche_id, type, by, demandeur_opener } | null.
	demande: null,
	// Réponse à la demande reçue par le DEMANDEUR : { fiche_id, type, accepted, by } | null.
	demandeReponse: null,
	postFichesOuvertes: {
		saving: false,
		saved: false,
		error: false,
	},
}

function setFicheOuverte(state = initialState, action) {
	switch (action.type) {
		case POST_FICHE_OUVERTE_BEGIN:
			return {
				...state,
				postFichesOuvertes: {
					saving: true,
					saved: false,
					error: false,
				},
			}
		case POST_FICHE_OUVERTE_RESET:
			return {
				...state,
				fichesOuvertes: [],
				postFichesOuvertes: {
					saving: false,
					saved: false,
					error: false,
				},
			}
		case POST_FICHE_OUVERTE_ERROR:
			return {
				...state,
				postFichesOuvertes: {
					saving: false,
					saved: false,
					error: action.payload,
				},
			}
		case POST_FICHE_OUVERTE_SUCCESS:
			return {
				...state,
				fichesOuvertes: action.payload,
				postFichesOuvertes: {
					saving: false,
					saved: false,
					error: false,
				},
			}
		case SET_FICHE_PRISE:
			return { ...state, prise: action.payload }
		case CLEAR_FICHE_PRISE:
			return { ...state, prise: null }
		case SET_FICHE_DEMANDE:
			return { ...state, demande: action.payload }
		case CLEAR_FICHE_DEMANDE:
			return { ...state, demande: null }
		case SET_FICHE_DEMANDE_REPONSE:
			return { ...state, demandeReponse: action.payload }
		case CLEAR_FICHE_DEMANDE_REPONSE:
			return { ...state, demandeReponse: null }
		default:
			return state
	}
}

export default setFicheOuverte
